import { useFormContext, useFormState } from 'react-hook-form';

interface IProps {
  fieldName: string;
  hide?: boolean;
}

export function ErrorMessage({ fieldName, hide = false }: IProps) {
  const { control } = useFormContext();
  const { errors } = useFormState({ control });

  const message = errors[fieldName]?.message as string | undefined;

  if (!message || hide) {
    return null;
  }

  return <p className='mt-1! mb-0! text-sm text-red-500'>{message}</p>;
}
